module.exports = __webpack_public_path__ + "img/中山大学附属第三医院.b79cf87b.png";